<template>
  <div>
    <template v-if="model && species && model[species.field]">
      <b-form-checkbox
        :id="species.name + '-checkbox'"
        class="invasive-checkbox"
        v-model="model[species.field].present"
        :name="species.name + '-checkbox'"
        @change="validateSpeciesOnPresent(model[species.field])"
      >
        {{ species.name }}
      </b-form-checkbox>
      <b-collapse
        id="collapse-4"
        v-model="model[species.field].present"
        class="mt-2">
        <div
          class="form-group valid row field-select invasive-row"
          :class="{error: showErrorsOnActiveTab && isMissingPercentage}">
          <label for="percent-infestation">
            Percent of Infestation<span class="required-symbol">*</span>
          </label>
          <div class="field-wrap">
            <b-form-select
              v-model="model[species.field].percentOfInfestation"
              :options="infestationOptions"
              @change="validateSpecies(model[species.field])">
            </b-form-select>
          </div>
          <div v-if="showErrorsOnActiveTab && isMissingPercentage"
               class="errors">
            Missing Percent
          </div>
        </div>
        <div
          class="form-group valid row field-input invasive-row"
          :class="{error: showErrorsOnActiveTab && isMissingSize}">
          <label for="infestation-size">
            Infestation Size (sq. ft.)<span class="required-symbol">*</span>
            <br/><span class="help-text">(Enter Whole Number Greater than 1)</span>
          </label>
          <div class="field-wrap">
            <b-form-input
              v-model="model[species.field].infestationSize"
              type='number'
              min="2"
              @change="validateSpecies(model[species.field])">
            </b-form-input>
          </div>
          <div v-if="showErrorsOnActiveTab && isMissingSize"
               class="errors">
            Size must be greater than 1 and not contain any decimals.
          </div>
        </div>
        <div class="form-group valid row field-textArea invasive-row">
          <label for="invasive-notes">
            Notes
            <br/><span class="help-text">(Max 250 characters)</span>
          </label>
          <div class="field-wrap">
            <richTextEditor maxSizeLimit="250"
            :value="model[species.field].notes" @input='changeNotes'/>
          </div>
        </div>
      </b-collapse>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import RichTextEditor from '@/components/common/RichTextEditor.vue';

export default {
  name: 'InvasiveDetails',
  components: { RichTextEditor },
  props: ['schema', 'model', 'species'],
  data() {
    return {
      infestationOptions: [
        { value: null, text: 'Please select an option' },
        { value: '<25%', text: '<25%' },
        { value: '25-50%', text: '25-50%' },
        { value: '51-75%', text: '51-75%' },
        { value: '>75%', text: '>75%' },
      ],
      isValid: true,
    };
  },
  computed: {
    ...mapState('SiteVisit', {
      showErrorsOnActiveTab: (state) => state.showErrorsOnActiveTab,
    }),
    isMissingPercentage() {
      return this.model[this.species.field].present
        && !this.model[this.species.field].percentOfInfestation;
    },
    isMissingSize() {
      return ((this.model[this.species.field].present
        && this.model[this.species.field].infestationSize <= 1)
        || (this.model[this.species.field].present && this.model[this.species.field].infestationSize.toString().includes('.')));
    },
  },
  methods: {
    validateSpecies() {
      if (this.isMissingPercentage || this.isMissingSize) {
        this.$emit('validated', false);
        this.isValid = false;
      } else {
        this.$emit('validated', true);
        this.isValid = true;
      }
    },
    validateSpeciesOnPresent() {
      // this looks backwards, but present hasn't changed yet when this method is called
      if (!this.model[this.species.field].present) {
        if (this.model[this.species.field].infestationSize <= 2
          || !this.model[this.species.field].percentOfInfestation
          || this.model[this.species.field].infestationSize.toString().includes('.')) {
          this.$emit('validated', false);
          this.isValid = false;
        } else {
          this.$emit('validated', true);
          this.isValid = true;
        }
      } else {
        this.model[this.species.field].infestationSize = null;
        this.model[this.species.field].percentOfInfestation = null;
        this.$emit('validated', true);
        this.isValid = true;
      }
    },
    changeNotes(newNotes) {
      this.model[this.species.field].notes = newNotes;
    },
  },
};
</script>
<style scoped>
  .error{
    color:red;
  }
</style>
